import { Link } from 'react-router-dom';

const columns = [
  {
    name: <span className="font-weight-bold fs-13">Nome</span>,
    sortable: true,

    id: 'name',
    cell: (cell) => {
      return (
        <>
          <div className="d-flex align-items-center fw-medium ">
            <Link
              className="currency_name"
              to={`/rede-credenciada/edit/${cell.id}`}
            >
              {cell.name}
            </Link>
          </div>
        </>
      );
    },
    selector: (cell) => cell.name && cell.name.toUpperCase(),
  },
  {
    name: <span className="font-weight-bold fs-13">CPF/CNPJ</span>,
    sortable: true,
    id: 'cpf',
    selector: (cell) => (cell.cnpj_cpf ? cell.cnpj_cpf : '-'),
  },
  {
    name: <span className="font-weight-bold fs-13">Cidade</span>,
    sortable: true,
    id: 'city',
    selector: (cell) => cell.city_name && cell.city_name.toUpperCase(),
  },
  {
    name: <span className="font-weight-bold fs-13">Bairro</span>,
    sortable: true,
    id: 'district',
    selector: (cell) => cell.district && cell.district.toUpperCase(),
  },
];

export { columns };
